import React from 'react'
import LogoContainer from '../components/LogoContainer'

import { imageVariants, textVariants, containerVariants } from '../script/animationVariants';
import Section1 from '../components/hakkimizda/Section1';
import Section2 from '../components/hakkimizda/Section2';
import Section3 from '../components/hakkimizda/Section3';
import Section4 from '../components/hakkimizda/Section4';
import Section5 from '../components/hakkimizda/Section5';









const Hakkimizda = () => {
    return (
        <div className=' bg-white w-full'>








            <div className='grid grid-cols-14'>

<Section1/>





<Section2/>

 <Section3/> 





<Section4/>





{/* 
<Section5/> */}












            </div>
        </div>




    )
}

export default Hakkimizda